import type { SupportedLanguage } from './language';
import { en } from './locales/en';
import { fr } from './locales/fr';
import type { Messages } from './messages';

/** Catalogues in the shape i18next expects, one `translation` namespace per language. */
export const resources = {
  fr: { translation: fr },
  en: { translation: en },
} as const satisfies Record<SupportedLanguage, { translation: Messages }>;
